export const formatFacilityWithType = (data: {
  facility?: {
    name: string;
  } | null;
  practiceSetting?: {
    displayText: string;
  } | null;
  facilityType?: {
    name: string;
  } | null;
}) => {
  const facilityName = data?.facility?.name ?? "";
  // Prefer practiceSetting, fall back to facilityType for org views
  const settingName =
    data?.practiceSetting?.displayText ?? data?.facilityType?.name ?? "";

  if (!facilityName && !settingName) {
    return "";
  }
  if (!facilityName) {
    return settingName;
  }
  if (!settingName) {
    return facilityName;
  }
  return `${facilityName} (${settingName})`;
};
